import React, { useState, useEffect } from 'react'
import { Link } from "react-router-dom"

function SiteMenu( data ) {
    const mobileMenu = <div className='mobileMenu'>
        <Link to='/PokerHands'>
            <button className="auxiliary" onClick={ ()=>{ data.toggleSiteMenu( false ) }}>Poker Hands</button>
        </Link>
        {/* <Link to='/FreeChips'>
            <button className="auxiliary" onClick={ ()=>{ data.toggleSiteMenu( false ) }}>Free Chips</button>
        </Link> */}
        <Link to='/PrivacyPolicy'>
            <button className="auxiliary" onClick={ ()=>{ data.toggleSiteMenu( false ) }}>Privacy Policy</button>
        </Link>
        <Link to='/TermsOfService'>
            <button className="auxiliary" onClick={ ()=>{ data.toggleSiteMenu( false ) }}>Terms of Service</button>
        </Link>
        <Link to='/ResponsibleGaming'>
            <button className="auxiliary" onClick={ ()=>{ data.toggleSiteMenu( false ) }}>Responsible Gaming</button>
        </Link>
        { data.user ?
            <Link>
                <button className="auxiliary" onClick={ ()=>{ logout() }}>Log Out</button>
            </Link>
            : null } 
        <Link to='/ContactUs'>
            <button className="mobileMenu_feedbackButton auxiliary" onClick={ ()=>{ data.toggleSiteMenu( false ) }}>
                Leave a Feedback
            </button>
        </Link>
        <button className="mobileMenu_closeButton auxiliary" onClick={ ()=>{ data.toggleSiteMenu( false ) } }>
            <svg className='mobileMenu_closeIcon' viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M40 21C40 31.4934 31.4934 40 21 40C10.5066 40 2 31.4934 2 21C2 10.5066 10.5066 2 21 2C31.4934 2 40 10.5066 40 21ZM42 21C42 32.598 32.598 42 21 42C9.40202 42 0 32.598 0 21C0 9.40202 9.40202 0 21 0C32.598 0 42 9.40202 42 21ZM12.8204 11.0995C12.2346 10.5137 11.2849 10.5137 10.6991 11.0995C10.1133 11.6853 10.1133 12.635 10.6991 13.2208L18.4773 20.999L10.6992 28.7772C10.1134 29.363 10.1134 30.3127 10.6992 30.8985C11.285 31.4843 12.2347 31.4843 12.8205 30.8985L20.5986 23.1203L28.3768 30.8985C28.9626 31.4843 29.9123 31.4843 30.4981 30.8985C31.0839 30.3127 31.0839 29.363 30.4981 28.7772L22.72 20.999L30.4982 13.2208C31.0839 12.635 31.0839 11.6853 30.4982 11.0995C29.9124 10.5137 28.9626 10.5137 28.3768 11.0995L20.5986 18.8777L12.8204 11.0995Z" fill="#D9D9D9"/>
            </svg>
        </button>
    </div>

    const desktopMenu = <div className='headerPlayerMenuDropdwon'>
        <div className='headerPlayerMenuDropdwonItems' onClick={ ()=>{ logout() }}><p>Loguot</p></div>
        <div className='headerPlayerMenuDropdwonBackdrop' onClick={ ()=>{ data.toggleSiteMenu( false ) }}></div>
    </div>

    if( data.showSiteMenu ){
        return(
        <div className='siteMenu'>
            { data.width < 1000 ? mobileMenu : desktopMenu }
            <div className='siteMenuBackdrop' onClick={ ()=>{ data.toggleSiteMenu( false ) }}></div>
        </div>
        )
    }
    
    function logout(){
        window.location.replace( '/logout' )
        data.toggleSiteMenu( false )
      }
}

export default SiteMenu